import { Box, Flex, Grid, GridItem, Text, VStack } from '@chakra-ui/layout';
import { Card } from '@chakra-ui/react';
import { isEmpty } from 'lodash';

import {
  hasEntitySummaryTab,
  useAuthStore,
  useGetLoggedInUser,
} from '@revelio/auth';
import { FeatureFlag } from '@revelio/core';

import { usePageVisitTracking } from '../../hooks/usePageVisitTracking';
import { useUnleashFlag } from '../../shared/unleash-flags/use-unleash-flag';
import DashboardPage from '../DashboardPage';
import PageCard from './PageCard';
import './landing.css';

import { getNewLayoutPageCardData, getPageCardData } from './landingCardData';
import { usePrefetchOverviewData } from './usePrefetchOverviewData';

const Landing = () => {
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);
  const { ory } = useAuthStore();
  const { loggedInUser } = useGetLoggedInUser();
  const user = isEmpty(loggedInUser) ? undefined : loggedInUser;
  const name = ory?.name;
  const firstName = name ? `, ${name?.split(' ')[0]}` : '';
  const userTabs = user?.tabs || [];
  const hasEntitySummary = hasEntitySummaryTab(userTabs);

  const cardData = isNewDashboardLayout
    ? getNewLayoutPageCardData(userTabs)
    : getPageCardData(hasEntitySummary);

  const visibleCards = cardData.filter(
    (card) => user && card.isVisible(userTabs)
  );

  const boxCount = visibleCards.length;
  const tmplRepeat = `repeat(${boxCount}, 1fr)`;

  usePageVisitTracking({
    page: 'Landing',
  });

  // Prefetch selection lists + overview chart data while user is on landing page
  usePrefetchOverviewData();

  return (
    <DashboardPage title={[`Welcome${firstName}!`]} loading={false}>
      <Grid
        height="100%"
        templateRows="1fr"
        templateColumns="1fr"
        data-testid="plots-grid"
      >
        <GridItem rowSpan={1} colSpan={1}>
          <Card h="100%">
            <Box h="100%" p={6}>
              <Flex
                h="100%"
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <VStack w="100%" alignItems="center" gap={12}>
                  <Text fontSize="4xl" fontWeight="semibold" textAlign="center">
                    Understand the workforce
                  </Text>
                  <Grid
                    templateColumns={{
                      base: 'repeat(1, 1fr)',
                      md: boxCount > 1 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)',
                      lg: user ? tmplRepeat : 'repeat(4, 1fr)',
                    }}
                    gap={6}
                  >
                    {visibleCards.map(({ isVisible: _, ...props }) => (
                      <GridItem key={props.path}>
                        <PageCard {...props} />
                      </GridItem>
                    ))}
                  </Grid>
                </VStack>
              </Flex>
            </Box>
          </Card>
        </GridItem>
      </Grid>
    </DashboardPage>
  );
};

export default Landing;
